import React from 'react';
import Modal from 'react-modal';
import theme from '../styles/theme';

type ModalSize = 'small' | 'medium' | 'large';

interface IProps {
    size: ModalSize;
    padding?: string;
    border?: string;
    minWidth?: number;
    width?: string;
    visible: boolean;
    children: any;
    closeModal: () => void;
    shouldCloseOnOverlayClick?: boolean;
    shouldCloseOnEsc?: boolean;
    classNames?: string;
}

const small = (padding: any, border: any, width: any) => {
    return {
        position: 'absolute',
        top: '50%',
        left: '50%',
        border: border ? border : `1px solid ${theme.colors.light.grayscale['400']}`,
        background: `${theme.constantStyles.colorStyles.white}`,
        borderRadius: '6px',
        outline: 'none',
        padding: padding ? padding : '20px',
        transform: 'translate(-50%, -50%)',
        width: width ? width : '33vw',
        maxWidth: width ? width : '33vw',
        height: 'auto',
    };
};

const medium = (padding: any, border: any, width: any) => {
    return {
        position: 'absolute',
        top: '50%',
        left: '50%',
        border: border ? border : `1px solid ${theme.colors.light.grayscale['400']}`,
        background: `${theme.constantStyles.colorStyles.white}`,
        overflow: 'auto',
        WebkitOverflowScrolling: 'touch',
        borderRadius: '6px',
        outline: 'none',
        padding: padding ? padding : '20px',
        transform: 'translate(-50%, -50%)',
        width: width ? width : 'initial',
        maxWidth: width ? width : '50vw',
        height: 'auto',
        maxHeight: '75vh',
    };
};

const large = (padding: any, border: any, width: any) => {
    return {
        position: 'absolute',
        top: '80px',
        left: '80px',
        right: '80px',
        bottom: '80px',
        border: border ? border : `1px solid ${theme.colors.light.grayscale['400']}`,
        background: `${theme.constantStyles.colorStyles.white}`,
        overflow: 'auto',
        WebkitOverflowScrolling: 'touch',
        borderRadius: '6px',
        outline: 'none',
        padding: padding ? padding : '20px',
        width: width ? width : 'initial',
    };
};

Modal.setAppElement('#root');

const MyModal = (props: IProps) => {
    const modalStyles: any =
        props.size === 'small'
            ? small(props.padding, props.border, props.width)
            : props.size === 'medium'
            ? medium(props.padding, props.border, props.width)
            : props.size === 'large'
            ? large(props.padding, props.border, props.width)
            : small(props.padding, props.border, props.width);

    return (
        <Modal
            className={`app-modal-component${props.classNames ? ' ' + props.classNames : ''}`}
            overlayClassName={`${
                props.classNames && (props.classNames === 'error' || props.classNames === 'success')
                    ? props.classNames
                    : ''
            }`}
            isOpen={props.visible}
            onRequestClose={() => {
                props.closeModal && props.closeModal();
            }}
            shouldCloseOnOverlayClick={props.shouldCloseOnOverlayClick}
            shouldCloseOnEsc={props.shouldCloseOnEsc}
            style={{
                overlay: {
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(105,105,105, 0.75)',
                },
                content: modalStyles,
            }}
        >
            {props.children}
        </Modal>
    );
};

MyModal.defaultProps = {
    visible: false,
    shouldCloseOnOverlayClick: true,
    shouldCloseOnEsc: false,
} as Partial<IProps>;

export default MyModal;
